import React from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';

export default function RecommendedItem(props) {

    const cleanValue = (value) => {
        return value.replace(/"|]|\[/g, '').trim();
    };

    return (
        <div className="recommended-item">
            <Accordion>
                <AccordionSummary id="panel-header" aria-controls="panel-content">
                    <div className="recommended-item__order">#{props.order}</div>
                    <figure>
                        {props.images && (
                            <img src={props.images.values[0]} alt={props.title}/>
                        )}
                    </figure>
                    <div className="recommended-item__info">
                        <p className="title">{props.title}</p>
                        <p className="itemId">{props.itemId}</p>
                    </div>
                </AccordionSummary>
                <AccordionDetails>
                    {props.allInformation.length > 0 ? (
                        props.allInformation.map((item, index) => (
                            <div key={index} className="item-info">
                                {Object.entries(item).map(([key, value]) => (
                                    <p key={key}>
                                        {key}: {cleanValue(value)}
                                    </p>
                                ))}
                            </div>
                        ))
                    ) : <p>None</p>}
                </AccordionDetails>
            </Accordion>
        </div>
    );
}
